import { cr } from "fire-wind-water";
import { movement, setCss } from "fire-wind-water/dom";

export class Carousel {
  constructor(opt) {
    this.setting = {
      playTime: 500,
      autoPlay: true,
      autoPlayTime: 5000,
      callback: cr.noop,
      change: cr.noop
    };
    this.index = 0;
    this.prevIndex = 0;
    this.isPlay = false;
    this.dt = null;
    cr.extend(true, this.setting, opt);
    this.resize();
    return this;
  }

  initChild() {
    if (this.elem) {
      this.childs = this.elem.children;
      this.initStyle();
    }
  }

  initElem(el) {
    this.elem = el;
    this.clientW = this.elem.clientWidth;
    this.childs = this.elem.children;
    this.initStyle();
    if (this.setting.autoPlay) {
      this.autoPlay();
      this.addEvent();
    }
  }

  initStyle() {
    cr.each(this.childs, (d, i) => {
      setCss(d, { left: i === this.index ? 0 : this.clientW });
    });
  }

  prev() {
    if (this.isPlay || this.childs.length <= 1) {
      return this.index;
    }
    this.prevIndex = this.index;
    this.index--;
    if (this.index < 0) {
      this.index = this.childs.length - 1;
    }
    return this.play(-1);
  }

  next() {
    if (this.isPlay || this.childs.length <= 1) {
      return this.index;
    }
    this.prevIndex = this.index;
    this.index++;
    if (this.index > this.childs.length - 1) {
      this.index = 0;
    }
    return this.play(1);
  }

  active(i) {
    if (this.isPlay || this.index === i || this.childs.length <= 1) {
      return this.index;
    }
    const t = this.index < i ? 1 : -1;
    this.prevIndex = this.index;
    this.index = i;
    return this.play(t);
  }

  play(n) {
    this.isPlay = true;
    this.setting.change(this.index);
    setCss(this.childs[this.index], { left: this.clientW * n });
    setCss(this.childs[this.prevIndex], { left: 0 });
    movement(this.childs[this.index], { left: 0 }, () => {}, {
      times: this.setting.playTime
    });
    movement(
      this.childs[this.prevIndex],
      { left: -this.clientW * n },
      () => {
        this.setting.callback(this.index);
        this.isPlay = false;
      },
      {
        times: this.setting.playTime + 100
      }
    );
    return this.index;
  }

  autoPlay() {
    clearInterval(this.dt);
    this.dt = setInterval(() => {
      this.next();
    }, this.setting.autoPlayTime);
  }

  stop() {
    clearInterval(this.dt);
  }

  addEvent() {
    if (this.elem) {
      this.elem.parentNode.onmouseenter = () => {
        this.stop();
      };
      this.elem.parentNode.onmouseleave = () => {
        this.autoPlay();
      };
    }
  }

  resize() {
    window.addEventListener(
      "resize",
      () => {
        this.clientW = this.elem.clientWidth;
      },
      false
    );
  }
}
